import React from 'react'

const Contacto = () => {


    return (
        <div>
            <h1>Contacto</h1>
        </div>
    )
}

export default Contacto